import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import DetailMobile from './DetailMobile';
import DetailDesktop from './DetailDesktop';

function Detail({ app, config }) {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    return isMobile ? <DetailMobile app={app} config={config} />
        : <DetailDesktop app={app} config={config} />;
}

Detail.defaultProps = {
    app: null,
    config: {}
};

Detail.propTypes = {
    app: PropTypes.object,
    config: PropTypes.object
};

export default Detail;
